import assert from 'assert';

import objectToGetParams from './utils/objectToGetParams';
import createShareButton from './utils/createShareButton';

function googlePlusLink(url) {
  assert(url, 'googlePlus.url');

  return 'https://plus.google.com/share' + objectToGetParams({ url: url });
}

var GooglePlusShareButton = createShareButton('googlePlus', googlePlusLink, undefined, undefined, {
  windowWidth: 550,
  windowHeight: 400
});

export default GooglePlusShareButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-share/es/GooglePlusShareButton.js
// module id = 1683
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21